export default __webpack_public_path__ + "static/media/logo.fe1e0eea.png";